export default __webpack_public_path__ + "static/media/home.e422f575.png";